import { rateGuarantee } from "./sharedTypedAmount";

import type { TypedAmountTypeOption } from "../typedAmountTypes";

const AMOUNT_LABEL = "Amount";
const DOLLAR_AMOUNT_VALUE = "dollarAmount";
const DOLLAR_AMOUNT_LABEL = "Dollar amount";

const SENTINEL_OPTIONS: TypedAmountTypeOption[] = [
  { value: "notDisclosed", label: "Not Disclosed", hideAmount: true },
  { value: "notIncluded", label: "Not Included", hideAmount: true },
  { value: "notOffered", label: "Not Offered", hideAmount: true },
];

const SPECIFIC_BENEFIT_OPTIONS: TypedAmountTypeOption[] = [
  { value: DOLLAR_AMOUNT_VALUE, label: DOLLAR_AMOUNT_LABEL },
  {
    value: "includedInLumpSumBenefitPayout",
    label: "Included in lump sum benefit payout",
    hideAmount: true,
  },
  ...SENTINEL_OPTIONS,
];

const SPECIFIC_BENEFIT_WITH_HOSPITAL_OPTIONS: TypedAmountTypeOption[] = [
  { value: DOLLAR_AMOUNT_VALUE, label: DOLLAR_AMOUNT_LABEL },
  {
    value: "includedInLumpSumBenefitPayout",
    label: "Included in lump sum benefit payout",
    hideAmount: true,
  },
  {
    value: "includedWithHospitalAdmission",
    label: "Included w/ Hospital Admission",
    hideAmount: true,
  },
  ...SENTINEL_OPTIONS,
];

const MAX_BENEFIT_OPTIONS: TypedAmountTypeOption[] = [
  { value: "upToDollarAmount", label: "Up to dollar amount" },
  ...SENTINEL_OPTIONS,
];

const WELLNESS_OPTIONS: TypedAmountTypeOption[] = [
  { value: DOLLAR_AMOUNT_VALUE, label: DOLLAR_AMOUNT_LABEL },
  { value: "notIncluded", label: "Not Included", hideAmount: true },
  { value: "notDisclosed", label: "Not Disclosed", hideAmount: true },
  { value: "notOffered", label: "Not Offered", hideAmount: true },
];

export interface AccidentTypedAmountSpec {
  typeKey: string;
  amountKey: string;
  amountLabel: string;
  typeOptions: TypedAmountTypeOption[];
  amountMin?: number;
  amountInteger?: boolean;
}

export const accidentTypedAmountFields: Record<
  string,
  AccidentTypedAmountSpec
> = {
  hospitalAdmission: {
    typeKey: "hospitalAdmissionType",
    amountKey: "hospitalAdmissionAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  icuAdmission: {
    typeKey: "icuAdmissionType",
    amountKey: "icuAdmissionAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_WITH_HOSPITAL_OPTIONS,
  },
  dailyHospitalConfinement: {
    typeKey: "dailyHospitalConfinementType",
    amountKey: "dailyHospitalConfinementAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  dailyIcuConfinement: {
    typeKey: "dailyIcuConfinementType",
    amountKey: "dailyIcuConfinementAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_WITH_HOSPITAL_OPTIONS,
  },
  ambulanceAir: {
    typeKey: "ambulanceAirType",
    amountKey: "ambulanceAirAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  ambulanceGround: {
    typeKey: "ambulanceGroundType",
    amountKey: "ambulanceGroundAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  emergencyTreatment: {
    typeKey: "emergencyTreatmentType",
    amountKey: "emergencyTreatmentAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  urgentCare: {
    typeKey: "urgentCareType",
    amountKey: "urgentCareAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  initialPhysicianOfficeVisit: {
    typeKey: "initialPhysicianOfficeVisitType",
    amountKey: "initialPhysicianOfficeVisitAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: SPECIFIC_BENEFIT_OPTIONS,
  },
  dislocationsMaximum: {
    typeKey: "dislocationsMaximumType",
    amountKey: "dislocationsMaximumAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  fracturesMaximum: {
    typeKey: "fracturesMaximumType",
    amountKey: "fracturesMaximumAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  lacerationsMaximum: {
    typeKey: "lacerationsMaximumType",
    amountKey: "lacerationsMaximumAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  coma: {
    typeKey: "comaType",
    amountKey: "comaAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  majorDiagnosticExamXray: {
    typeKey: "majorDiagnosticExamXrayType",
    amountKey: "majorDiagnosticExamXrayAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  majorDiagnosticExamMri: {
    typeKey: "majorDiagnosticExamMriType",
    amountKey: "majorDiagnosticExamMriAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: MAX_BENEFIT_OPTIONS,
  },
  wellnessBenefit: {
    typeKey: "wellnessBenefitType",
    amountKey: "wellnessBenefitAmount",
    amountLabel: AMOUNT_LABEL,
    typeOptions: WELLNESS_OPTIONS,
  },
  rateGuarantee,
};
